import React, { Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addOverlay, removeOverlay } from '../Actions/Overlay.action';
import { translate } from '../Services/translation';

const NavigationMegaMenu = ({
  open,
  onMegaMenuClose,
  onMouseOverMegaMenu,
  onMouseLeaveMegaMenu,
  link,
  block,
}) => {
  const dispatch = useDispatch();

  const { blockBackgroundColor, blockContent, blockImage } = link;

  useEffect(() => {
    if (open) {
      dispatch(addOverlay('MegaMenu', onMegaMenuClose));
    } else {
      dispatch(removeOverlay('MegaMenu'));
    }
  }, [open]);

  return (
    <div
      className={`mega-menu show-for-medium ${open ? 'mega-menu--open' : ''}`}
      onMouseLeave={onMouseLeaveMegaMenu}
      onMouseOver={onMouseOverMegaMenu}
    >
      <div className="row">
        <div className="columns small-12">
          <div className="mega-menu__content">
            <div className="mega-menu__links-wrapper">
              {link.links?.length > 0 &&
                link.links.map((subLink, index) => (
                  <div
                    key={link.url + 'sub' + index}
                    className="mega-menu__link-group"
                  >
                    {subLink.url ? (
                      <a
                        className="mega-menu__link-group-header"
                        href={subLink.url}
                      >
                        {subLink.name}
                      </a>
                    ) : (
                      <p className="mega-menu__link-group-header">
                        {subLink.name}
                      </p>
                    )}
                    {subLink.links?.length > 0 &&
                      subLink.links.map((subSubLink) => (
                        <a
                          key={subLink.url + 'sub2' + subSubLink.url}
                          href={subSubLink.url}
                          className="[ mega-menu__sublink ] [ text-medium lh-2 ]"
                        >
                          {subSubLink.name}
                          <i className="ph-caret-right"></i>
                        </a>
                      ))}
                  </div>
                ))}
            </div>
            {blockContent?.value && (
              <div className="mega-menu__block-area">
                <div
                  style={{
                    backgroundColor: blockBackgroundColor,
                    backgroundImage: blockImage ? `url(${blockImage})` : null,
                  }}
                  className="mm-block__image"
                >
                  <div
                    className="mm-block__content"
                    dangerouslySetInnerHTML={{ __html: blockContent.value }}
                  ></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationMegaMenu;
